export default "/assets/images/technology-hero.webp?c8cb345c7fbbb967f837cd8508aa4c8a";